import withSuspense from "../../../../hocs/withSuspense";
import {
  EditMailingAddressPageProps,
  EditMailingAddressPage,
} from "./EditMailingAddressPage";
import { SettingsPageSkeleton, SettingsError } from "../../components";

export const EditMailingAddressPageWithSuspense =
  withSuspense<EditMailingAddressPageProps>(EditMailingAddressPage, {
    FallbackComponent: SettingsError,
    loading: <SettingsPageSkeleton rows={5} testId="edit-mailing-address" />,
  });
